import React, { Component } from 'react';
import style from '../share/pageList.module.css';
import TextBoxWithLabel from '../../components/TextBoxWithLabel.js';
//import CheckBoxWithLabel from '../../components/CheckBoxWithLabel.js';
//import SearchBtn from '../../components/SearchBtn.js';
import DefaultBtn from '../../components/DefaultBtn.js';
import Paging from '../../components/Paging.js';
import BackDropLoading from '../../components/BackDropLoading.js';
import DataUpdate from './UserControlUpdate.js';
//import axios from 'axios';
import TemplateV2 from '../../components/TemplateV2';
import * as utils from '../../Utils.js';

// import logoImage from '../assets/images/header_logo.svg';
// import MenuLeft from './MenuLeft.js';
//import artwork from '../assets/images/artwork.svg';

class UserControl extends Component {

    constructor(props) {
        //alert("Hotel");
        super(props);
        this.state = {
            showCreate: false,
            showDelete: false,
            selectId: null,
            selectMethod: "",
            loading: true,
            dataObject: null,
            searchObject: {
                Name: ""
            },
            Page: 1
        };
    }
    componentDidMount() {
        this.props.appState.checkUser(this.props.appState);
        this.callGetData(1);
    }
    callGetData(page) {
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/GetUserList";
        let data = {};

        data.searchObject = { ...this.state.searchObject };
        data.Page = page;
        let appState = this.props.appState;
        let token = appState.userObject.Token;

        utils.callPost(url,token,data,this.callGetDataCallBack);

        this.setState({
            loading: true
        })
    }
    callGetDataCallBack=(res)=>{
        //console.log(data);
        let data = res.Data;
        this.setState({
            dataObject: { ...data },
            Page:data.page,
            loading: false
        })
    }

    handleChange = (e) => {
        //alert("change");
        let searchObject = { ...this.state.searchObject };
        if (e.target.name === "Name") searchObject.Name = e.target.value;

        this.setState({
            searchObject: searchObject,
        })
    }
    pagingClick = (page) => {
        // let dataObject = { ...this.state.dataObject }
        // dataObject.page = page;
        // this.setState({
        //     dataObject: dataObject,
        // })
        this.callGetData(page);
    }
    searchClick = () => {
        this.callGetData(1);
    }
    showDelete(Id) {
        this.setState({
            showCreate: true,
            selectId: Id,
            selectMethod: "Delete"
        })
    }
    showEdit(Id) {
        this.setState({
            showCreate: true,
            selectId: Id,
            selectMethod: "Edit"
        })
    }
    showCreate = () => {
        this.setState({
            showCreate: true,
            selectId: null,
            selectMethod: "Create"
        })
    }
    hideCreate = () => {
        //alert("test");
        this.setState({
            showCreate: false,
            showDelete: false,
            selectId: null,
            selectMethod: "Create"
        })
        this.callGetData(1);
    }
    renderTable() {
        let tableRow = [];;
        let dataObject = this.state.dataObject;

        if (dataObject !== null) {
            let dataList = dataObject.dataList;

            for (let i = 0; i < dataList.length; i++) {
                let node = dataList[i];
                let active = node.IsEnable === true ? "Enable" : "Disable";

                tableRow.push(
                    <tr key={node.Id}>
                        <td onClick={(e) => this.showEdit(node.Id)} className={style.columnPointer}>{node.Email}</td>

                        <td>{node.FirstName}</td>
                        <td>{node.LastName}</td>
                        <td>{node.RoleString}</td>


                        <td>{active}</td>
                        <td>
                            {/* <i className="fas fa-edit"></i> */}
                            <i onClick={(e) => this.showDelete(node.Id)} className="fas fa-trash-alt"></i>
                        </td>
                    </tr>
                );
            }
        }

        return (
            <div className={style.tableArea}>
                <table>
                    <thead>
                        <tr>
                            <th>Email</th>
                            <th>First Name</th>
                            <th>LastName</th>
                            <th>Role</th>
                            <th>Active</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>

                    <tbody>
                        {tableRow}
                    </tbody>


                </table>
                {dataObject !== null &&
                    <Paging dataObject={dataObject} onClick={this.pagingClick} />
                }
            </div>
        );
    }

    render() {
        let table = this.renderTable();
        return (

            <TemplateV2 appState={this.props.appState} page={"usercontrol"}>
                <div className={style.page}>
                    <BackDropLoading show={this.state.loading} key="hotel" />

                    <div className={style.navBar}>
                        <div className={style.nav}>Home</div>
                        <i className="fas fa-chevron-right"></i>
                        <div className={style.navSelect}>User Control</div>
                        {/* <i className="fas fa-chevron-right"></i>
                    <div className={style.navSelect}>Create</div> */}
                    </div>

                    {this.state.showCreate !== true && this.state.loading !== true && this.state.showDelete !== true &&

                        <>
                            <div className={style.searchArea}>
                                <div className={style.searchBox}>
                                    <div className={style.searchBoxInput}>
                                        <TextBoxWithLabel onChange={this.handleChange} value={this.state.searchObject.Name} name="Name" label="Name" />
                                    </div>
                                    <div className={style.searchBoxBtn}>
                                        <DefaultBtn label="Search" type="primary" onClick={this.searchClick} />
                                    </div>
                                </div>
                            </div>

                            <div className={style.contentArea}>
                                <div className={style.contentBox}>
                                    <div className={style.contentTitle}>User List</div>

                                    <div className={style.line}></div>

                                    <div className={style.toolArea}>
                                        <div className={style.toolBtn} onClick={this.showCreate}>
                                            <i className="fas fa-plus"></i>
                                            Create
                                        </div>
                                    </div>
                                    <div className={style.line}></div>
                                    {table}
                                </div>
                            </div>
                        </>
                    }
                    {this.state.showCreate === true &&
                        <DataUpdate Id={this.state.selectId} onClose={this.hideCreate} method={this.state.selectMethod} appState={this.props.appState} />
                    }
                </div>
            </TemplateV2>



        );
    }
}
export default UserControl